exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-slider--horizontal .v-slider__track-container{height:5px!important;cursor:pointer!important}", ""]);

// exports
